// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { Box, CircularProgress, TextField, MenuItem, Typography, Button, FormControl, InputLabel, Select } from "@mui/material";
// import { Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
// import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
// import { fetchAttendance, fetchLocations } from "../actions/jobHistoryAllAction";
// import HeaderBannerPage from "../components/HeaderBannerPage";
// import { useLocation } from "react-router-dom";
// import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
// import { FiArrowUpRight, FiArrowDownLeft } from "react-icons/fi";
// // import { Line } from "react-chartjs-2";
// // import Chart from "chart.js/auto";

// const JobsHistoryAll = () => {
//   const dispatch = useDispatch();
  
//   const location = useLocation();
//   const department = location.state?.department;
//   const role = location.state?.role;
//   const { attendance, locations, loading } = useSelector((state) => state.attendance);
//   const [openDatePicker, setOpenDatePicker] = useState(false);
//   const [selectedDate, setSelectedDate] = useState(new Date());
//   const [selectedLocation, setSelectedLocation] = useState(role);
//   const [attendanceData, setAttendanceData] = useState([]);


//   useEffect(() => {
//     if (department) {
//       dispatch(fetchLocations(department));
//     }
//   }, [dispatch, department]);



//   const handleDateChange = async (date) => {
//     setSelectedDate(date);
//     const formattedDate = date.toISOString().split("T")[0];
//     try {
//       await dispatch(fetchAttendance(formattedDate, role));
//     } catch (error) {
//       console.error("Error fetching attendance:", error);
//     }
//   };

//   const handleLocationChange = (event) => {
//     setSelectedLocation(event.target.value);
//     const formattedDate = selectedDate.toISOString().split("T")[0];
//     dispatch(fetchAttendance(formattedDate, event.target.value));
//   };

 

//   return (
//     <LocalizationProvider dateAdapter={AdapterDateFns}>
//       <Box sx={{ padding: 0, margin: "0 auto" }}>
//         <HeaderBannerPage />

//         <Box sx={{ padding: "16px", maxWidth: "600px", margin: "0 auto", mt: -5 }}>
//           <Box display="flex" justifyContent="center" my={2}>
//             <Button
//               variant="contained"
//               color="primary"
//               onClick={() => setOpenDatePicker(true)}
//               sx={{
//                 width: "80%",
//                 borderRadius: "20px",
//                 backgroundColor: "#142c54",
//                 color: "#fff",
//                 fontWeight: "bold",
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//               }}
//             >
//               <CalendarTodayIcon sx={{ marginRight: 2 }} />
//               Choose a Date
//             </Button>
//           </Box>

//           {openDatePicker && (
//             <DatePicker
//               open={openDatePicker}
//               value={selectedDate}
//               onChange={handleDateChange}
//               onClose={() => setOpenDatePicker(false)}
//               renderInput={(params) => <TextField {...params} sx={{ display: "none" }} />}
//             />
//           )}

//           <Box display="flex" justifyContent="center" my={2}>
//             <FormControl fullWidth>
//               <InputLabel sx={{ fontSize: { xs: "0.9rem", sm: "1rem" } }}>Location</InputLabel>
//               <Select
//                 value={selectedLocation}
//                 onChange={handleLocationChange}
//                 label="Location"
//                 sx={{
//                   fontSize: { xs: "0.9rem", sm: "1rem" },
//                   borderRadius: "20px",
//                   backgroundColor: "#F0F4F8",
//                   boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
//                   "& .MuiSelect-icon": {
//                     color: "#154C79",
//                   },
//                   "& .MuiInputLabel-root": {
//                     color: "#154C79",
//                   },
//                 }}
//               >
//                 {loading ? (
//                   <MenuItem value="">Loading...</MenuItem>
//                 ) : (
//                   locations.map((location, index) => (
//                     <MenuItem key={index} value={location.location}>
//                       {location.locationDescription}
//                     </MenuItem>
//                   ))
//                 )}
//               </Select>
//             </FormControl>
//           </Box>

//           {/* Line Chart */}
//           {/* <Box sx={{ marginTop: "30px" }}>
//             <Typography variant="h6" sx={{ textAlign: "center", marginBottom: "15px" }}>
//               Attendance Status Overview
//             </Typography>
//             <Line data={chartData} options={{ responsive: true }} />
//           </Box> */}

//           <Box sx={{ maxHeight: "420px", overflowY: "auto", marginTop: "30px" }}>
//             {loading ? (
//               <Box sx={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
//                 <CircularProgress />
//               </Box>
//             ) : attendance && attendance.length > 0 ? (
//               attendance.map((group, groupIndex) => (
//                 <Accordion key={groupIndex} sx={{ marginBottom: "10px" }}>
//                   <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ backgroundColor: "#F0F4F8" }}>
//                     <Typography sx={{ fontWeight: "bold", color: "#333" }}>
//                       {group.JobDecription}
//                     </Typography>
//                   </AccordionSummary>
//                   <AccordionDetails>
//                     {group.AttendancList && group.AttendancList.length > 0 ? (
//                       group.AttendancList.map((record, recordIndex) => (
//                         <Box
//                           key={recordIndex}
//                           sx={{
//                             display: "flex",
//                             justifyContent: "space-between",
//                             padding: "10px",
//                             borderBottom: "1px solid #ddd",
//                           }}
//                         >
//                           <Box>
//                             <Typography variant="body1" sx={{ fontWeight: "bold", color: "#142c54"}}>
//                               {record.serviceNo}
//                             </Typography>
//                             <Typography variant="body2" sx={{ fontWeight: "bold",}}>{record.EmpName}</Typography>
//                           </Box>
//                           <Box>
//                             <Typography
//                               variant="body2"
//                               sx={{ color: "#239B56", fontWeight: "bold" }}
//                             >
//                               {record.inTime || "No In Time"}
//                               <FiArrowDownLeft size={15}  />
//                             </Typography>
//                             <Typography
//                               variant="body2"
//                               sx={{ color: "#E74C3C", fontWeight: "bold" }}
//                             >
//                               {record.outTime || "Out"}
//                               <FiArrowUpRight size={15}  />
//                             </Typography>
//                           </Box>
//                         </Box>
//                       ))
//                     ) : (
//                       <Typography>No attendance records available.</Typography>
//                     )}
//                   </AccordionDetails>
//                 </Accordion>
//               ))
//             ) : (
//               <Typography variant="body1" sx={{ textAlign: "center", padding: "20px" }}>
//                 No attendance records available.
//               </Typography>
//             )}
//           </Box>
//         </Box>
//       </Box>
//     </LocalizationProvider>
//   );
// };

// export default JobsHistoryAll;


import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, CircularProgress, TextField, MenuItem, Typography, Button, FormControl, InputLabel, Select } from "@mui/material";
import { Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { fetchAttendance, fetchLocations } from "../actions/jobHistoryAllAction";
import HeaderBannerPage from "../components/HeaderBannerPage";
import { useLocation } from "react-router-dom";
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { FiArrowUpRight, FiArrowDownLeft } from "react-icons/fi";
const JobsHistoryAll = () => {
  const dispatch = useDispatch();
  const { attendance, locations, loading } = useSelector((state) => state.attendance);
  const [openDatePicker, setOpenDatePicker] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date()); // Set to current date initially
  const [selectedLocation, setSelectedLocation] = useState("");
  const [attendanceData, setAttendanceData] = useState([]);
  const location = useLocation();
  const department = location.state?.department;
  const role = location.state?.role;
  // Fetch locations when department is available
  useEffect(() => {
    if (department) {
      dispatch(fetchLocations(department));
    }
  }, [dispatch, department]);
  // Fetch attendance data for current date when component mounts
  useEffect(() => {
    const formattedDate = selectedDate.toISOString().split("T")[0];
    dispatch(fetchAttendance(formattedDate, role));
  }, [dispatch, selectedDate, role]);
  const handleDateChange = async (date) => {
    setSelectedDate(date);
    const formattedDate = date.toISOString().split("T")[0];
    try {
      await dispatch(fetchAttendance(formattedDate, role));
    } catch (error) {
      console.error("Error fetching attendance:", error);
    }
  };
  const handleLocationChange = (event) => {
    setSelectedLocation(event.target.value);
    const formattedDate = selectedDate.toISOString().split("T")[0];
    dispatch(fetchAttendance(formattedDate, event.target.value));
  };
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Box sx={{ padding: 0, margin: "0 auto" }}>
        <HeaderBannerPage />
        <Box sx={{ padding: "16px", maxWidth: "600px", margin: "0 auto", mt: -5 }}>
          <Box display="flex" justifyContent="center" my={2}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => setOpenDatePicker(true)}
              sx={{
                width: "80%",
                borderRadius: "20px",
                backgroundColor: "#142C54",
                color: "#fff",
                fontWeight: "bold",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CalendarTodayIcon sx={{ marginRight: 2 }} />
              Choose a Date
            </Button>
          </Box>
          {openDatePicker && (
            <DatePicker
              open={openDatePicker}
              value={selectedDate}
              onChange={handleDateChange}
              onClose={() => setOpenDatePicker(false)}
              renderInput={(params) => <TextField {...params} sx={{ display: "none" }} />}
            />
          )}
          <Box display="flex" justifyContent="center" my={2}>
            <FormControl fullWidth>
              <InputLabel sx={{ fontSize: { xs: "0.9rem", sm: "1rem" } }}>Location</InputLabel>
              <Select
                value={selectedLocation}
                onChange={handleLocationChange}
                label="Location"
                // sx={{
                //   fontSize: { xs: "0.9rem", sm: "1rem" },
                //   borderRadius: "20px",
                //   backgroundColor: "#F0F4F8",
                //   boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                //   "& .MuiSelect-icon": {
                //     color: "#154C79",
                //   },
                //   "& .MuiInputLabel-root": {
                //     color: "#154C79",
                //   },
                // }}
                sx={{
                      fontSize: { xs: "0.85rem", sm: "1rem" },
                      borderRadius: "20px",
                      backgroundColor: "#F0F4F8",
                      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                      "& .MuiSelect-icon": {
                        color: "#154C79",
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#154C79",
                      },
                    }}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          maxHeight: 250, // Ensures the dropdown has a max height and becomes scrollable
                          overflowY: "auto",
                        },
                      },
                    }}
              >
                {loading ? (
                  <MenuItem value="">Loading...</MenuItem>
                ) : (
                  locations.map((location, index) => (
                    <MenuItem key={index} 
                    value={location.location}
                    sx={{
                              whiteSpace: "normal", 
                              wordWrap: "break-word", // Prevents overflow by wrapping long words
                              padding: "7px 16px", 
                              fontWeight: "400", 
                              fontSize: "14px", 
                              lineHeight: "1.5", 
                              overflow: "hidden", 
                              textOverflow: "ellipsis", 
                              '&:hover': {
                                backgroundColor: "rgba(0, 0, 0, 0.08)", // Adds hover effect for better interactivity
                              },
                              '&.Mui-selected': {
                                backgroundColor: "rgba(0, 0, 0, 0.12)", // Changes selected background color
                              },
                     }}
                    >
                      {location.locationDescription}
                    </MenuItem>
                  ))
                )}
              </Select>
            </FormControl>
          </Box>
          <Box sx={{ maxHeight: "420px", overflowY: "auto", marginTop: "30px" }}>
            {loading ? (
              <Box sx={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
                <CircularProgress />
              </Box>
            ) : attendance && attendance.length > 0 ? (
              attendance.map((group, groupIndex) => (
                <Accordion key={groupIndex} sx={{ marginBottom: "10px" }}>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ backgroundColor: "#F0F4F8" }}>
                    <Typography sx={{ fontWeight: "bold", color: "#333" }}>
                      {group.JobDecription}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    {group.AttendancList && group.AttendancList.length > 0 ? (
                      group.AttendancList.map((record, recordIndex) => (
                        <Box
                          key={recordIndex}
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "10px",
                            borderBottom: "1px solid #ddd",
                          }}
                        >
                          <Box>
                            <Typography variant="body1" sx={{ fontWeight: "bold", color: "#142C54" }}>
                              {record.serviceNo}
                            </Typography>
                            <Typography variant="body2" sx={{ fontWeight: "bold" }}>{record.EmpName}</Typography>
                          </Box>
                          <Box>
                            <Typography
                              variant="body2"
                              sx={{ color: "#239B56", fontWeight: "bold" }}
                            >
                              {record.inTime || "No In Time"}
                              <FiArrowDownLeft size={15} color="#239B56" />
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{ color: "#E74C3C", fontWeight: "bold" }}
                            >
                              {record.outTime || "Out"}
                              <FiArrowUpRight size={15} color="#154C79" />
                            </Typography>
                          </Box>
                        </Box>
                      ))
                    ) : (
                      <Typography>No attendance records available.</Typography>
                    )}
                  </AccordionDetails>
                </Accordion>
              ))
            ) : (
              <Typography variant="body1" sx={{ textAlign: "center", padding: "20px" }}>
                No attendance records available.
              </Typography>
            )}
          </Box>
        </Box>
      </Box>
    </LocalizationProvider>
  );
};
export default JobsHistoryAll;